<template>
    <div class="panel">
        <div class="panel_head fx fx-m_between fx-c_start">
            <el-form :inline="true" :model="form" >
                <el-form-item label="关键词">
                    <el-input v-model="form.keywords" placeholder="关键词"></el-input>
                </el-form-item>
                <el-form-item label="身份">
                    <el-select v-model="type" clearable  placeholder="全部">
                        <el-option label="员工" :value="1"></el-option>
                        <el-option label="学生" :value="2"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>
        <div class="panel_body">
            <el-table
                :data="tableData"
                stripe
                style="width: 100%">
                <el-table-column
                    min-width="180"
                    prop="name"
                    label="姓名" >
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="phone"
                    label="手机号" >
                </el-table-column>
                <el-table-column
                    prop="sn"
                    min-width="180"
                    label="账号" >
                </el-table-column>
                <el-table-column
                    prop="score"
                    min-width="180"
                    label="积分" >
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    min-width="180"
                    label="注册时间" >
                </el-table-column>
                <el-table-column
                    prop="fromChannelName"
                    min-width="180"
                    label="来源" >
                </el-table-column>
                <el-table-column
                    min-width="180"
                    label="身份" >
                    <template slot-scope="scope">
                        <el-tag type="primary" size="mini" effect="dark" v-if="scope.row.isStaff" class="tag">员工</el-tag>
                        <el-tag type="warning" size="mini"  effect="dark" v-if="scope.row.isStudent" class="tag">学生</el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    min-width="180"
                >
                    <template slot-scope="scope">

                        <el-link type="primary" @click="edit(scope.row)"
                                 :underline="false" ><i class="iconfont icon-bianji"></i><b>编辑</b></el-link>
                        <el-popconfirm @onConfirm="del(scope.row)"
                                       title="确认删除该用户吗？"
                        >
                            <el-link type="danger" slot="reference"
                                     :underline="false" ><i class="iconfont icon-shanchu"></i><b>删除</b></el-link>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="panel_foot fx fx-m_end fx-c_center">
            <el-pagination
                :background="true"
                prev-text="上一页"
                next-text="下一页"
                layout="prev, pager, next"
                :current-page="pager.currentPage"
                :page-size="pager.pageSize"
                :total="pager.dataTotal"
                @current-change="pageChange"
            >
            </el-pagination>
        </div>

        <EditDrawer v-if="showEdit" @submit="loadData" :item="editItem"
                    @close="showEdit=false" ></EditDrawer>
    </div>
</template>

<style scoped>
    .tag{
        margin: 0 8px;
    }

</style>
<style>

</style>

<script>

    import EditDrawer from './UserEditDrawer';


    export default {
        components: {
            EditDrawer,
        },
        props: [
            "attr"
        ],
        data() {
            return {
                showEdit: false,
                editItem: {},


                form: {
                    keywords: "",
                },
                type: null,

                pager: {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                },
                tableData: [  ],
            }

        },

        watch: {
            "form": {
                handler: function (newValue) {
                    this.pager.currentPage = 1;
                    this.loadData();
                },
                deep: true,
                immediate: true

            },
            type: function () {
                this.pager.currentPage = 1;
                this.loadData();
            }
        },

        methods: {
            add() {
                this.showAdd = true;
            },
            edit(item) {
                this.editItem = {...item};
                this.showEdit = true;
            },
            del(item) {
                this.$ajaxGet("/user/del/" + item.id, (data) => {
                    this.loadData();
                })
            },

            loadData() {
                this.$ajaxPost("/user/list", {
                    form: this.form,
                    isStaff: this.type == 1 ? true : null,
                    isStudent: this.type == 2 ? true : null,
                    pager: {...this.pager, dataTotal: 0}
                }, (data) => {
                    //分页不能带offset，否则会影响后台计算最新offset
                    let {offset, ...pager} = data.pager;
                    this.pager = pager;
                    this.tableData = data.result;
                    this.showEdit = false;
                })
            },
            pageChange(page) {
                this.pager.currentPage = page;
                this.loadData();
            },


        },

        created() {
        }

    }
</script>
